import { TableEmptyState } from '@practium/ui';
import type { LandingPlanItem } from '../../../types/landing.types';
import styles from '../LandingTable.module.css';

interface LandingPlansTableProps {
	plans: LandingPlanItem[];
	onRowClick?: (planId: string, landingPlanId: string) => void;
}

export const LandingPlansTable = ({ plans, onRowClick }: LandingPlansTableProps) => {
	if (plans.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum plano encontrado"
				subtitle="Indexe um plano para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Hierarquia</th>
						<th>Valor</th>
						<th>Usuários</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{plans.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item.planId, item.landingPlanId)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.hierarchy}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>
									{(item.price / 100).toLocaleString('pt-BR', {
										style: 'currency',
										currency: 'BRL',
									})}
								</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.linkedUsers.toLocaleString('pt-BR')}</span>
							</td>
							<td>
								<span
									className={`${styles.statusBadge} ${
										item.status === 'active' ? styles.statusActive : styles.statusInactive
									}`}
								>
									{item.status === 'active' ? 'Ativo' : 'Inativo'}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
